import { postJsonRequest } from "../../utils/requestHelper";

export let launchDatabaseServiceManualAggregation = databaseServiceManuelAggregationOptions => async dispatch => {
  dispatch({ type: "CALL_DATABASE_SERVICE" });

  let url = process.env.REACT_APP_API_URL +"/api/database-service/launch-manual-aggregation";

  try {
    let response = await postJsonRequest(url, databaseServiceManuelAggregationOptions);
    dispatch({ type: 'OPEN_SUCCESS', payload: 'Success calling dabatase service manual aggregation !' });
  } catch (error) {
    dispatch({ type: 'OPEN_ERROR', payload: 'Error during calling dabatase service manual aggregation !' });    
  }

  dispatch({ type: "DATABASE_SERVICE_CALL_ENDED" });
};


// WEBPACK FOOTER //
// ./src/actions/Maintenance/DatabaseServiceActions.js